/**
 * A value that settles before it is used.
 *
 * Search runs per keystroke otherwise, which is a request and a charge for
 * every letter of a word nobody has finished typing.
 */

import { useEffect, useState } from 'react';

export function useDebounced<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);

  return settled;
}
